import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

const values = [
  { icon: 'ri-heart-3-fill', title: '用心聚合', desc: '精选优质少女漫画、恋爱漫画、唯美漫画与耽美漫画，让每一部作品都值得被遇见。' },
  { icon: 'ri-lightbulb-fill', title: '阅读至上', desc: '坚持点开即读的轻量体验，分类清晰、加载迅速，把时间还给阅读本身。' },
  { icon: 'ri-verified-badge-fill', title: '尊重创作', desc: '倡导支持正版与原创，让热爱漫画的读者与作者都能得到应有的尊重。' },
];

const principles = [
  '内容精选而非海量堆砌，只推荐真正值得阅读的作品',
  '优先展示当日更新的热门漫画，追更更省心',
  '保持页面清爽，减少广告打扰，专注阅读体验',
  '如实标注连载状态与更新时间，信息透明可信',
  '持续听取读者反馈，不断优化分类与推荐逻辑',
  '携手版权方，为优秀作品提供更多展示机会',
];

const testimonials = [
  { name: '林小姐', role: '少女漫画爱好者', text: '樱花漫画网的分类特别清楚，我追的《樱之夏》每次更新都能第一时间看到，收藏后追更超省心。' },
  { name: '阿哲', role: '日漫新番党', text: '新番同步很快，热血连载《花火纪元》我一集没落下。页面干净不卡，读起来很舒服。' },
  { name: '小唯', role: '唯美漫画书迷', text: '被《雾中灯塔》感动到不行，画风和故事都很唯美。这里的完结推荐质量真的很高。' },
];

export default function AboutPage() {
  useDocumentMeta(
    '关于我们 - 樱花漫画网',
    '了解樱花漫画网：我们专注日漫阅读，用心聚合少女漫画、唯美漫画、校园恋爱与耽美漫画，倡导正版阅读，提供清晰分类与点开即读的追更体验。',
  );

  return (
    <>
      <Navbar />
      <main className="pt-16 md:pt-[72px]">
        {/* 横幅 */}
        <section className="relative overflow-hidden bg-primary-500 py-16 md:py-20">
          <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-primary-300/30"></div>
          <div className="absolute -left-10 bottom-0 h-40 w-40 rounded-full bg-accent-400/30"></div>
          <div className="relative mx-auto max-w-4xl px-4 text-center md:px-6">
            <span className="rounded-full bg-background-50/20 px-4 py-1 text-xs font-medium text-background-50">关于樱花漫画网</span>
            <h1 className="font-heading mt-5 text-3xl font-bold text-background-50 md:text-4xl">以阅读之名，遇见更多心动</h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-primary-50 md:text-base">
              樱花漫画网是一处专注日漫阅读的在线追更平台。我们聚合少女漫画、唯美漫画、校园恋爱与耽美漫画，热门日漫新番同步更新，用清晰分类与点开即读的体验，陪伴每一位漫画爱好者。
            </p>
          </div>
        </section>

        {/* 我们的定位与理念 */}
        <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
            <div>
              <span className="text-xs font-medium uppercase tracking-widest text-primary-600">ABOUT</span>
              <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">关于樱花漫画网</h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600">
                樱花漫画网诞生于对日漫文化的热爱。我们相信，好的漫画能在忙碌生活里带来片刻的治愈与心动。为此，我们专注做好一件事——把分类做得更清晰，把更新做得更及时，把阅读做得更流畅。
              </p>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                网站定位为面向中文读者的轻量日漫阅读社区，覆盖少女、恋爱、唯美、耽美等多个分类，并同步热门日漫新番连载。无论是通勤路上的碎片时间，还是深夜的安静时光，都能在这里找到想读的作品。
              </p>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-xl bg-background-100 p-5 text-center">
                  <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 font-semibold text-foreground-900">{v.title}</h3>
                  <p className="mt-2 text-xs leading-5 text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 内容原则 */}
        <section className="bg-background-100 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="mx-auto max-w-2xl text-center">
              <span className="text-xs font-medium uppercase tracking-widest text-accent-600">PRINCIPLES</span>
              <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">我们的内容原则</h2>
              <p className="mt-3 text-sm text-foreground-600">为读者呈现高质量、可信赖的阅读内容，是我们始终坚持的标准。</p>
            </div>
            <ul className="mx-auto mt-8 grid max-w-4xl grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <li key={p} className="flex items-start gap-3 rounded-lg bg-background-50 p-4 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-accent-500"></i>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* 读者口碑 */}
        <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
          <div className="mx-auto max-w-2xl text-center">
            <span className="text-xs font-medium uppercase tracking-widest text-secondary-600">VOICE</span>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">读者这样说</h2>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-xl bg-background-100 p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <blockquote className="mt-4 text-sm leading-6 text-foreground-600">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-sm font-semibold text-primary-700">
                    {t.name[0]}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mx-auto max-w-5xl px-4 pb-12 md:px-6 md:pb-16">
          <div className="rounded-2xl bg-gradient-to-r from-accent-500 to-accent-600 px-6 py-10 text-center md:px-10">
            <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">想和我们聊聊？</h2>
            <p className="mx-auto mt-3 max-w-lg text-sm text-accent-50">
              无论是内容建议、版权合作还是使用反馈，都欢迎随时联系我们。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/contact"
                className="rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-accent-700 whitespace-nowrap transition hover:bg-background-100"
              >
                联系我们
              </Link>
              <Link
                to="/category/all"
                className="rounded-full border border-background-50/70 px-6 py-3 text-sm font-semibold text-background-50 whitespace-nowrap transition hover:bg-background-50/15"
              >
                去逛逛漫画
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* AboutPage 结构化数据 */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于樱花漫画网',
          description: '樱花漫画网专注日漫阅读，聚合少女漫画、唯美漫画、校园恋爱与耽美漫画，热门日漫新番同步更新。',
          inLanguage: 'zh-CN',
        })}
      </script>
    </>
  );
}